import { useState } from "react";
import emailjs from "emailjs-com";
import React from "react";

const initialState = {
  name: "",
  email: "",
  message: "",
};
export const Contact = (props) => {
  const [{ name, email, message }, setState] = useState(initialState);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setState((prevState) => ({ ...prevState, [name]: value }));
  };
  const clearState = () => setState({ ...initialState });
  
  
  const handleSubmit = async (e) => {
  e.preventDefault();

  try {
    const response = await fetch(
      "https://api.jrhtechnology.com/send-email",
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          name,
          email,
          message,
        }),
      }
    );

    const result = await response.json();

    if (result.ok) {
      alert("Mensaje enviado correctamente");
      clearState();
    } else {
      alert("Error al enviar el mensaje");
    }
  } catch (error) {
    console.error(error);
    alert("Error de conexión");
  }
};
  // Preparar enlaces: WhatsApp (wa.me) con mensaje predefinido y tel: como fallback
  const phoneNumber = props.data && props.data.phone ? props.data.phone.replace(/\D/g, "") : "";
  const telLink = props.data && props.data.phone ? `tel:${props.data.phone.replace(/\s+/g, "")}` : "#";
  const defaultWhatsappMessage = "Hola, estoy contactando desde el sitio web.";
  const whatsappMessage = props.data && props.data.whatsappMessage ? props.data.whatsappMessage : defaultWhatsappMessage;
  const whatsappLink = phoneNumber
    ? `https://wa.me/${phoneNumber}?text=${encodeURIComponent(whatsappMessage)}`
    : "#";
  return (
    <div>
      <div id="contact">
        <div className="container">
          <div className="col-md-8">
            <div className="row">
              <div className="section-title">
                <h2>Contactanos</h2>
                <p>
                  Puedes contactarnos por correo electrónico al llenar este formulario, nosotros estaremos estaremos contactándote a la brevedad.
                </p>
              </div>
              <form name="sentMessage" validate onSubmit={handleSubmit}>
                <div className="row">
                  <div className="col-md-6">
                    <div className="form-group">
                      <input
                        type="text"
                        id="name"
                        name="name"
                        className="form-control"
                        placeholder="Name"
                        required
                        onChange={handleChange}
                      />
                      <p className="help-block text-danger"></p>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="form-group">
                      <input
                        type="email"
                        id="email"
                        name="email"
                        className="form-control"
                        placeholder="Email"
                        required
                        onChange={handleChange}
                      />
                      <p className="help-block text-danger"></p>
                    </div>
                  </div>
                </div>
                <div className="form-group">
                  <textarea
                    name="message"
                    id="message"
                    className="form-control"
                    rows="4"
                    placeholder="Message"
                    required
                    onChange={handleChange}
                  ></textarea>
                  <p className="help-block text-danger"></p>
                </div>
                <div id="success"></div>
                <button type="submit" className="btn btn-custom btn-lg">
                  Mandar Mensaje
                </button>
              </form>
            </div>
          </div>
          <div className="col-md-3 col-md-offset-1 contact-info">
            <div className="contact-item">
              <h3>Información de Contacto</h3>
              <p>
                <span>
                  <i className="fa fa-map-marker"></i> Dirección
                </span>
                {props.data ? props.data.address : "loading"}
              </p>
            </div>
            <div className="contact-item">
              <p>
                <span>
                  <i className="fa fa-phone"></i> Teléfono
                </span>{" "}
                {props.data ? (
                  <>
                    <span className="phone-number">{props.data.phone}</span>
                    {" "}
                    <a href={whatsappLink} target="_blank" rel="noopener noreferrer" className="contact-link">
                      <i className="fa fa-whatsapp"></i> WhatsApp
                    </a>
                    {" "}
                    <a href={telLink} className="contact-link">
                      <i className="fa fa-phone"></i> Llamar
                    </a>
                  </>
                ) : (
                  "loading"
                )}
              </p>
            </div>
            <div className="contact-item">
              <p>
                <span>
                  <i className="fa fa-envelope-o"></i> Correo Electrónico
                </span>{" "}
                {props.data ? props.data.email : "loading"}
              </p>
            </div>
          </div>
          <div className="col-md-12">
            <div className="row">
              <div className="social">
                <ul>
                  <li>
                    <a href={props.data ? props.data.facebook : "/"}>
                      <i className="fa fa-facebook"></i>
                    </a>
                  </li>
                  <li>
                    <a href={props.data ? props.data.instagram : "/"}>
                      <i className="fa fa-instagram"></i>
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div id="footer">
        <div className="container text-center">
        </div>
      </div>
    </div>
  );
};
